module.exports = __webpack_public_path__ + "img/cons_6.91f6f336.jpg";